import { makeStyles } from 'tss-react/mui';

export const subPadding = 25;

const useStyles = makeStyles()((theme) => ({
  listItemText: {
    ...theme.typography.h3,
    color: theme.palette.background.contrastText,
  },

  subList: {
    paddingTop: 0,
    marginBottom: 5,
  },

  subListItemText: {
    ...theme.typography.h5,
  },

  expandIcon: {
    fill: theme.palette.background.contrastText,
  },
}));

// TODO jss-to-tss-react codemod: usages of this hook outside of this file will not be converted.
export default useStyles;
